import { useSelector, useDispatch } from 'react-redux';
import settingsActionCreators from '../actions/settingsActionCreators';
const defaultObj = {};
const useLookup = key => {
  var _settings$customStrin;
  const _useSelector = useSelector(state => {
      var _state$settings;
      return (_state$settings = state === null || state === void 0 ? void 0 : state.settings) !== null && _state$settings !== void 0 ? _state$settings : defaultObj;
    }),
    settings = _useSelector.settings,
    loaded = _useSelector.loaded,
    loading = _useSelector.loading;
  const dispatch = useDispatch();
  if (loaded !== undefined && !loaded && !loading) {
    dispatch(settingsActionCreators.serverLoad());
  }
  const alternativeString = settings === null || settings === void 0 || (_settings$customStrin = settings.customStrings) === null || _settings$customStrin === void 0 ? void 0 : _settings$customStrin[key];
  return alternativeString !== null && alternativeString !== void 0 ? alternativeString : key;
};

/**
 * This is exported this way so it's easier to test.
 * Using the object style export we're more easily able to mock
 * and disable it during test runs.
 */
export default useLookup;